import React from 'react';

const GoalComp = ({ isGoldenGoal, goal, homeGoal }) => {
  const customAttributes = {'m-l': 'true' };
  if (homeGoal) {
    return (
      <>
        <td>
          <div className="d-flex align-items-center justify-content-center">
            <span className={`timeline__icon ${isGoldenGoal ? 'icon-gold' : 'icon-ball'}`} />
            {' '}
            <span className="w-100">
              <div>{`${isGoldenGoal ? 'Golden' : ''} Goal`}</div>
              {goal?.goalscorer && <div className="timeline__scorer-info">{`( ${goal?.goalscorer} )`}</div>}
            </span>
            {' '}
            <span className="timeline__min">{`${goal?.matchMinute}'`}</span>
          </div>
        </td>
        <td>{`${goal?.homeScore} : ${goal?.awayScore}`}</td>
      </>
    );
  }

  return (
    <>
      <td />
      <td>{`${goal?.homeScore} : ${goal?.awayScore}`}</td>
      <td>
        <div className="d-flex align-items-center justify-content-center">
          <span className="timeline__min">{`${goal?.matchMinute}'`}</span>
          {' '}
          <span className="w-100" {...customAttributes}>
            <div>{`${isGoldenGoal ? 'Golden' : ''} Goal`}</div>
            {goal?.goalscorer && <div className="timeline__scorer-info">{`( ${goal?.goalscorer} )`}</div>}
          </span>
          {' '}
          <span className={`timeline__icon ${isGoldenGoal ? 'icon-gold' : 'icon-ball'}`} />
        </div>
      </td>
    </>
  );
};

export default GoalComp;
